export { useStaticToasts } from './useStaticToasts';
